import { BrowserRouter as Router, Switch, Route, } from "react-router-dom";
import { CssBaseline } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './themes';
import LandingPage from './components/LandingPage';
import Service from './components/Service';
import { tours, courses } from './data';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Router>
          <Switch>
            {tours.map(({ path, title, text, image, price }) => (
              <Route key={path} path={path}>
                <Service type={title} text={text} image={image} price={price} />
              </Route>
            ))}
            {courses.map(({ path, title, imageURL }) => (
              <Route key={path} path={path}>
                <Service type={title} image={imageURL} />
              </Route>
            ))}
            <Route path="/" >
              <LandingPage />
            </Route>
          </Switch>
        </Router>
      </div >
    </ThemeProvider>
  );
}

export default App;
